export default "<div class=\"loader-container\"></div>"